export const ContentType = {
    AdBuilder: 'ad_builder',
    AdSet3rdParty: 'ad_set_3rd_party',
    AdSetCostco: 'ad_set_costco',
    AnnouncementBanner: 'announcement_banner',
    Category: 'category',
    CategoryLandingPage: 'category_landing_page',
    ConfigurationSetting: 'Configuration_Setting',
    CustomMarkdown: 'custom_markdown',
    DynamicLandingPageBuilder: 'dynamic_landing_page_builder',
    FeatureHighlightCard: 'feature_highlight_card',
    FeatureToggle: 'Feature_Toggle',
    Footer: 'footer_scaffold',
    Header: 'header_scaffold',
    HomePage: 'homepage',
    LinkListSimple: 'link_list_simple',
    LinkListWithFlyout: 'link_list_with_flyout',
    ModuleSettings: '_module_settings',
    PageSettings: '_page_settings',
    ServiceConfiguration: 'Service_Configuration',
    SiteSettings: '_site_settings',
    SystemDefinedLink: 'system_defined_link',
    SearchKeywords: '_search_keyword', // Deprecated, don't use
    SearchPage: 'search_results_page',
    SearchPageV2: 'search_results_page_v2',
    SearchRule: 'search_rule',
    SearchRuleV2: 'search_rule_v2',
    ButtonSet: 'button_set',
} as const;

export const SEARCH_V2_FEATURE_TOGGLE = 'search_rule_v2_feature_toggle';
